/**
 * セクショングループ詳細ページ専用i18n定数
 */

export const DISTRIBUTOR_DETAILS_I18N = {
  // 契約ステータス
  contractStatus: {
    active: $localize`:@@systemAdmin.sectionGroupDetails.contractStatus.active:有効`,
    inactive: $localize`:@@systemAdmin.sectionGroupDetails.contractStatus.inactive:無効`,
  },

  // 管理者割り当て
  assignAgent: {
    later: $localize`:@@systemAdmin.sectionGroupDetails.assignAgent.later:エージェントをあとで割り当てる`,
    self: $localize`:@@systemAdmin.sectionGroupDetails.assignAgent.self:自分自身をエージェントにする`,
  },

  // バリデーションメッセージ
  validation: {
    checkFields: $localize`:@@systemAdmin.sectionGroupDetails.validation.checkFields:各フィールドの内容を再度確認してください`,
    userDataFormatError: $localize`:@@systemAdmin.sectionGroupDetails.validation.userDataFormatError:ユーザーデータ設定のフォーマットにエラーがあります。`,
    selectAtLeastOneFunction: $localize`:@@systemAdmin.sectionGroupDetails.validation.selectAtLeastOneFunction:利用可能な機能を最低ひとつ選択してください。`,
    jsonParseError: $localize`:@@systemAdmin.sectionGroupDetails.validation.jsonParseError:[JSON パースエラー]`,
  },

  // メッセージ
  message: {
    createSuccess: $localize`:@@systemAdmin.sectionGroupDetails.message.createSuccess:セクショングループを作成しました。`,
    createWithAdminSuccess: $localize`:@@systemAdmin.sectionGroupDetails.message.createWithAdminSuccess:セクショングループを作成し、現在のユーザーを管理者に割り当てました。`,
    createAdminError: $localize`:@@systemAdmin.sectionGroupDetails.message.createAdminError:セクショングループを作成しましたが管理者の登録に失敗しました。\nシステム管理者にご連絡ください。`,
    createError: $localize`:@@systemAdmin.sectionGroupDetails.message.createError:セクショングループの更新に失敗しました。`,
    updateSuccess: $localize`:@@systemAdmin.sectionGroupDetails.message.updateSuccess:セクショングループの情報を更新しました。`,
    updateError: $localize`:@@systemAdmin.sectionGroupDetails.message.updateError:セクショングループの情報の更新に失敗しました。\n再度お試しください。\nこの問題が継続する場合はシステム管理者にご連絡ください。`,
  },

  // ダイアログ
  dialog: {
    confirmTitle: $localize`:@@systemAdmin.sectionGroupDetails.dialog.confirmTitle:ダイアログ確認`,
    confirmMessage: $localize`:@@systemAdmin.sectionGroupDetails.dialog.confirmMessage:ダイアログが表示されます`,
  },

  // ボタン
  button: {
    close: $localize`:@@systemAdmin.sectionGroupDetails.button.close:閉じる`,
  },
} as const;

export type SectionGroupDetailsI18n = typeof DISTRIBUTOR_DETAILS_I18N;
